//
//
//
//
//
//
//
//
//
//
//
//
import PageHeader from '~/components/common/PageHeader.vue';
export default {
  components: {
    PageHeader
  },

  data() {
    return {
      fromApp: false
    };
  },

  mounted() {
    var _window;

    this.fromApp = !!((_window = window) !== null && _window !== void 0 && _window.sessionStorage.getItem('EXTRA_FROM_APP'));
  }

};